/** BroadcastChannel name for cross-tab EventBus fan-out. */
export const BROADCAST_CHANNEL_NAME = 'bv_channel';
